import Vue from 'vue'
import Vuex from 'vuex'
import { getInfo } from '../api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: {}
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER(state, user) {
      state.userInfo = user
    },
    LOGOUT(state) {
      state.token = ''
      state.userInfo = {}
      localStorage.removeItem('token')
    }
  },
  actions: {
    async fetchUserInfo({ commit }) {
      const res = await getInfo()
      commit('SET_USER', res.data)
    }
  }
})
